import { useEffect } from 'react';
import { io } from 'socket.io-client';
import { useAuth } from '../contexts/AuthContext';

// Phase 2 — every logged-in browser (agent or client) holds a /live socket so the admin
// can ask it to mirror its helpdesk view. Recording (rrweb) runs ONLY while being watched,
// and rrweb is lazy-imported so it never enters the initial bundle for normal use.
// Inputs are masked (we stream what they're doing, not what they type).
export default function LiveCaptureAgent() {
  const { user } = useAuth();

  useEffect(() => {
    if (!user) return undefined;
    const token = localStorage.getItem('accessToken');
    if (!token) return undefined;

    const socket = io('/live', { auth: { token }, transports: ['websocket'], reconnection: true });
    let rrweb = null;        // lazy-loaded module
    let stopFn = null;
    let buffer = [];
    let flushIv = null;
    let cancelled = false;

    const flush = () => {
      if (buffer.length) { socket.emit('live:events', { events: buffer }); buffer = []; }
    };
    const startCapture = async () => {
      if (stopFn) return;
      try {
        if (!rrweb) rrweb = await import('rrweb');
        if (cancelled || stopFn) return;
        buffer = [];
        stopFn = rrweb.record({
          emit: (event) => { buffer.push(event); },
          recordCanvas: false,
          collectFonts: false,
          maskAllInputs: true,
          sampling: { mousemove: 50, scroll: 150, input: 'last' },
        });
        flushIv = setInterval(flush, 600);
      } catch { /* rrweb failed — ignore */ }
    };
    const stopCapture = () => {
      if (flushIv) { clearInterval(flushIv); flushIv = null; }
      flush();
      if (stopFn) { try { stopFn(); } catch {} stopFn = null; }
      buffer = [];
    };

    socket.on('live:start-capture', startCapture);
    socket.on('live:request-snapshot', () => { if (stopFn && rrweb) { try { rrweb.record.takeFullSnapshot(true); } catch {} } });
    socket.on('live:stop-capture', stopCapture);

    return () => {
      cancelled = true;
      socket.off('live:start-capture', startCapture);
      socket.off('live:request-snapshot');
      socket.off('live:stop-capture', stopCapture);
      stopCapture();
      socket.disconnect();
    };
  }, [user]);

  return null;
}
